export enum WebinarType {
  MEETING = 'meeting',
  WEBINAR = 'webinar'
}
